import { ThemeConfig } from "antd";

export const docnodesTheme: ThemeConfig = {
  token: {
    // colorPrimary: "#e6193d", // red
    colorPrimary: "#ed8f1f", // mint
    colorLink: "#003d58",
  },
  components: {
    Badge: {
      colorError: "#24b3a7",
      colorErrorHover: "#24b3a7",
    },
    Tabs: { colorPrimary: "#003d58", colorPrimaryHover: "#003d58" },
  },
};
